import { render, staticRenderFns } from "./NavbarHamburger.vue?vue&type=template&id=f642e8f2&scoped=true&lang=pug&"
import script from "./NavbarHamburger.vue?vue&type=script&lang=js&"
export * from "./NavbarHamburger.vue?vue&type=script&lang=js&"
import style0 from "./NavbarHamburger.vue?vue&type=style&index=0&id=f642e8f2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f642e8f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f642e8f2')) {
      api.createRecord('f642e8f2', component.options)
    } else {
      api.reload('f642e8f2', component.options)
    }
    module.hot.accept("./NavbarHamburger.vue?vue&type=template&id=f642e8f2&scoped=true&lang=pug&", function () {
      api.rerender('f642e8f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/navigation/NavbarHamburger.vue"
export default component.exports